import { useState } from 'react';

export default function FAQSection() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  const faqs = [
    {
      question: "What if I don't have a set of golf clubs?",
      answer: "Clubs available for use for Right Handed Golfers. Left Handed Clubs available by special request."
    },
    {
      question: "What are the onsite requirements?",
      answer: "High-speed internet, electricity, and a minimum space of 15ft wide × 15ft long × 10ft high. Ideal surfaces include patios, lanais, driveways, or similar flat areas. We'll handle all the setup and breakdown."
    },
    {
      question: "Can minors participate?",
      answer: "Yes, with parental consent. We offer kid-friendly formats for birthday parties and youth events. Our equipment is safe and suitable for children under adult supervision."
    },
    {
      question: "Do you offer catering or decorations?",
      answer: "Optional add-ons are available for catering, decorations, and custom scorecards. We can coordinate with local vendors or you can provide your own. Let us know your needs when booking."
    },
    {
      question: "What contests are available?",
      answer: "Longest Drive, Closest to Pin, Scramble formats, and custom leaderboard challenges. We can create tournaments tailored to your event with prizes and awards ceremonies."
    },
    {
      question: "How accurate is the Garmin r50 launch monitor?",
      answer: "While optical-camera launch monitors can't promise 100% accuracy with every shot, the Garmin r50 delivers exceptional performance shot-by-shot with ball and club data. Some Users report accuracy up to 0.2 MPH Ball Speed and an Irons play variance of less than 5 yards offering incredible reliability."
    },
    {
      question: "How far in advance should I book?",
      answer: "We recommend booking at least 2-3 weeks in advance, especially for weekends and peak seasons. However, we'll do our best to accommodate last-minute requests based on availability."
    },
    {
      question: "What happens if there is inclement weather?",
      answer: "In the event of inclement or unfavorable conditions, we will work with you to reschedule your booking, rain check, or provide a refund. Our simulator works great indoors! If your outdoor event needs to move inside due to weather, we can adapt to covered patios, garages, or indoor spaces that meet our size requirements."
    },
    {
      question: "Does Great Golf On The Go serve my community?",
      answer: "We serve St Johns County, including Saint Johns, Mandarin, Julington Creek, St Augustine, Beachwalk, Nocatee, and surrounding areas. Additional event locations will be considered."
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  return (
    <section id="faq" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Got questions? We've got answers! Here are the most common questions about our mobile golf simulator service.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div key={index} className="bg-white rounded-lg border border-gray-200 overflow-hidden">
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full px-6 py-5 text-left focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-inset cursor-pointer hover:bg-gray-50 transition-colors duration-200"
                >
                  <div className="flex items-center justify-between">
                    <h3 className="text-lg font-semibold text-gray-900 pr-4">
                      {faq.question}
                    </h3>
                    <div className="flex-shrink-0">
                      <i className={`ri-${openFAQ === index ? 'subtract' : 'add'}-line text-green-600 text-xl transition-transform duration-200`}></i>
                    </div>
                  </div>
                </button>
                
                {openFAQ === index && (
                  <div className="px-6 pb-5">
                    <div className="border-t border-gray-200 pt-4">
                      <p className="text-gray-600 leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <div className="bg-green-600 rounded-xl p-8 text-white">
              <h3 className="text-2xl font-bold mb-4">Still Have Questions?</h3>
              <p className="text-green-100 mb-6">
                Can't find what you're looking for? We're here to help! Contact us directly and we'll be happy to answer any specific questions about your event.
              </p>
              <button 
                onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                className="bg-white text-green-600 px-8 py-3 rounded-lg font-semibold hover:bg-green-50 transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                Contact Us
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
